export const pageReducerCreator = (routesMap, defaultPage) => (
  state = defaultPage,
  action = {},
) => {
  let page = state;
  const route = routesMap[action.type];

  if (route) {
    page = route.page || route.component;
    if (!page) {
      if (action.meta && action.meta.location && action.payload && action.payload.page) {
        ({ page } = action.payload);
      } else {
        page = defaultPage;
      }
    }
  }

  return page;
};
